import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../context/ProductBuilder/machine';
import { Cart as CartIcon } from '../Icon';
import { CartNumber } from './CartNumber';

type Props = HTMLAttributes<HTMLAnchorElement>;

const CartLink = styled.a<Props>`
  display: inline-block;
  position: relative;
`;

export const Cart = () => {
  const [state] = useService(productBuilderMachine);
  const {
    store: { cartUrl },
  } = state.context;
  return (
    <CartLink href={cartUrl} title="View your cart">
      <CartIcon style={{ width: '24px' }} />
      <CartNumber />
    </CartLink>
  );
};
